module.exports = {
    API_KEY : "d42a0d190464a2be90977c3996382811",
    ANALYSER_URL : "https://analyser2.u-winn.net/",
    
    // API_ADMIN_URL : "https://sales.u-winn.net/v1/admin/",
    // API_BASE_URL : "https://sales.u-winn.net/",
    // ASSETS_BASE_URL : "https://sales.u-winn.net/",
    // HOURLY_ANALYSER_URL : "https://testanalyzer002.gamedubai.primeapps.co.in/",
    
    API_ADMIN_URL : "https://crm.u-winn.net/v1/admin/",
    API_BASE_URL : "https://crm.u-winn.net/",
    ASSETS_BASE_URL : "https://crm.u-winn.net/",
    HOURLY_ANALYSER_URL : "https://testanalyzer002.gamedubaiprod.primeapps.co.in/",

    
    // API_ADMIN_URL   : "http://localhost:3300/v1/admin/",
    // API_BASE_URL    : "http://localhost:3300/",
    // ASSETS_BASE_URL : "http://localhost:3300/",
    // ANALYSER_URL    : "http://localhost:61010/",
    
} 